module.exports = __webpack_public_path__ + "static/media/british-columbia.c05a7a90.svg";